import React from "react";

function ContinuationNB() {
  return (
    <div style={{border:"1px solid black",padding:"10px"}}>
      <p>
        <span className="nb">NB:</span> Pentagonians are kindly asked to adhere
        to any amendment made in addition to any other bright regulations that
        may be produced from time to time. Students/parents/guardians are kindly
        asked to take note of these rules and regulations and make sure that
        your child has a face mask and sanitizers to protect him/her from the
        pandemic of COVID-19
      </p>
      <h6>Student’s Full Name</h6>
      <h6>……………………………………………………………………………………..Sign……………….........…….………..</h6>
      <h6>Parent’s/Guardian’s Name…………………………………………....Sign…………………………….</h6>
      <h6>Tel……………………………………………………………………………………………………………….............………</h6>
      <h6>Principal’s Signature………………………………………………………Date…/……………202..…….</h6>
      <h6>Tel……………………………………………………………………………………………………………………….............</h6>
    </div>
  );
}

export default ContinuationNB;
